// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"e229a1ff","56":"a0e1548c","239":"a8fb41a4","305":"c356dad3","403":"be2b5a40","430":"22416ead","455":"316c7710","762":"b7f848cd","772":"895110cc","884":"79dac54b","959":"a633b622"}[chunkId] + ".chunk.js";
};